<mat-accordion class="accordion" [multi]="true">
  <mat-expansion-panel [expanded]="true" [hideToggle]="true" class="panel-locked container-panel">
    <mat-expansion-panel-header class="header-panel">
      <mat-panel-title>
        <b>{{ "ui.ffurflenarchwiliadteitl" | translate | uppercase }}</b>
      </mat-panel-title>
    </mat-expansion-panel-header>
    <div class="container-content">
      <formly-group [field]="field"></formly-group>
    </div>
  </mat-expansion-panel>
</mat-accordion>
